export default __webpack_public_path__ + "static/banner-b09f12b5266b5d7908040ad7ae8e3fee.png";